// Auto generated file, do not manually modify!
// com.hotpads.capps.client.enums.applicationconfiguration.SettingParameterUnit

export enum SettingParameterUnit {
  MONTHS = 'MONTHS',
  TAX_YEARS = 'TAX_YEARS',
}

export const SettingParameterUnit_values = [SettingParameterUnit.MONTHS, SettingParameterUnit.TAX_YEARS] as const;
